import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import { getContactedUsers } from "../utils/methods.js";
import { strings } from "../utils/index.js";
import usePersistData from "../store/usePersistData.js";

const ContactUs = ({ userId }) => {
  const { user } = usePersistData();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        let userData = await getContactedUsers();
        const sortedGoals = userData.sort((a, b) => {
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
        setData(sortedGoals);
      } catch (error) {
        console.error("Error fetching goals:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [userId, user]);

  return (
    <div className="mt-4 mx-8 flex flex-col justify-end">
      <div className="flex justify-between mb-8">
        <p className="text-[32px] font-semibold">{strings["contacted"]}</p>
      </div>

      <TableContainer component={Paper} sx={{ border: "2px solid border" }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Name</TableCell>
              <TableCell align="center">Email</TableCell>
              <TableCell align="center">Message</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : data.length > 0 ? (
              data.map((data, index) => (
                <TableRow key={index}>
                  <TableCell align="center">{data?.name || ""}</TableCell>
                  <TableCell align="center">{data?.email || ""}</TableCell>
                  <TableCell align="center">{data?.message || ""}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No record found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ContactUs;
